import React, { useState, useEffect } from 'react';
import {
  Avatar,
  Box,
  Card,
  CardContent,
  Divider,
  IconButton,
  Typography,
  Button
} from '@mui/material';
import { toast } from 'react-toastify';
import Navbar from '../../global/Navbar';
import { Add } from '@mui/icons-material';
import { shades } from '../../../../theme.js';
import NoGroups from '../../../components/medichat/groups/noGroups.jsx';
import { useSelector, useDispatch } from 'react-redux';
import { userGroups, dummyGroups } from '../../../../../dummy_data.js';

import SideBar from '../../../components/medichat/sidebar.jsx';
import Profile from '../../../components/medichat/profile.jsx';
import AddGroupDialog from '../../../components/medichat/groups/addGroups.jsx';
import {
  createGroup,
  fetchGroups
} from '../../../redux/middleware/medichat/groups/groups.js';

// Main Groups Section
const Groups = () => {
  const dispatch = useDispatch();
  const [openDialog, setOpenDialog] = useState(false);
  const { groups } = useSelector((state) => state.groups) || [];

  useEffect(() => {
    dispatch(fetchGroups());
  }, [dispatch]);

  const handleGroupCreation = () => {
    setOpenDialog(true);
  };

  const handleSubmit = async (groupData) => {
    try {
      dispatch(createGroup(groupData));
      toast.success('Group created successfully!');
    } catch (error) {
      toast.error('Failed to create group. Please try again later.');
    }
  };

  return (
    <Box
      sx={{
			  flexGrow: 1,
			  p: 1.5,
			  backgroundColor: '#f8f9fa',
			  overflowY: 'auto',
			  marginTop: '10vh',
			  maxHeight: 'calc(100vh - 10vh)'
      }}
    >
      <Box
        display='flex'
        justifyContent='space-between'
        alignItems='center'
        mb={2}
      >
        <Typography
          variant='h6'
          sx={{ color: shades.neutral[900], fontWeight: 'bold' }}
        >
          Groups
        </Typography>
        <Button
          variant='contained'
          onClick={handleGroupCreation}
          sx={{
					  backgroundColor: 'black',
					  borderRadius: 4,
					  color: 'white',
					  '&:hover': { backgroundColor: shades.neutral[800], color: 'white' }
          }}
        >
          New Group
        </Button>
        {/* <IconButton color="primary" onClick={handleGroupCreation}>
                    <Add />
                </IconButton> */}
      </Box>

      {/* Add group dialogue */}
      <AddGroupDialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        onSubmit={handleSubmit}
      />
      <Typography
        variant='h6'
        sx={{ mb: 2, color: shades.neutral[900], fontWeight: 'bold' }}
      >
        Your Groups
      </Typography>
      {groups.length > 0
        ? (
			  groups.map((group) => (
  <Card
    key={group.id}
    sx={{
						  mb: 2,
						  backgroundColor: '#fff',
						  boxShadow: 'none',
						  border: '1px solid #ddd'
    }}
  >
    <CardContent>
      <Box display='flex' alignItems='center' mb={1}>
        <Avatar sx={{ mr: 2 }} />
        <Box>
          <Typography
            variant='subtitle1'
            sx={{ color: shades.neutral[900] }}
          >
            {group.name}
          </Typography>
          <Typography
            variant='body2'
            sx={{ color: shades.neutral[500] }}
          >
            {group.description}
          </Typography>
          <Typography
            variant='caption'
            sx={{ color: shades.neutral[500] }}
          >
            Admin: {group.admin.first_name} {group.admin.last_name}
          </Typography>
        </Box>
      </Box>
      <Divider sx={{ my: 1 }} />
      <Box
        display='flex'
        alignItems='center'
        mb={2}
        sx={{ color: shades.neutral[500] }}
      >
        <Typography variant='body2' sx={{ mr: 1 }}>
          {group.members.length} member
          {group.members.length > 1 ? 's' : ''}
        </Typography>
        {group.members.map((member) => (
          <Avatar
            key={member.id}
            src={member.avatar}
            sx={{ width: 24, height: 24, mr: 0.5 }}
          />
        ))}
      </Box>
    </CardContent>
  </Card>
			  ))
          )
        : (
          <NoGroups />
          )}
      <Typography
        variant='h6'
        sx={{ mb: 2, color: shades.neutral[900], fontWeight: 'bold' }}
      >
        Suggested Groups
      </Typography>
      {userGroups.map((group) => (
        <Card
          key={group.id}
          sx={{
					  mb: 2,
					  backgroundColor: '#fff',
					  boxShadow: 'none',
					  border: '1px solid #ddd'
          }}
        >
          <CardContent>
            <Box display='flex' alignItems='center' mb={1}>
              <Avatar sx={{ mr: 2 }} />
              <Box>
                <Typography
                  variant='subtitle1'
                  sx={{ color: shades.neutral[900] }}
                >
                  {group.name}
                </Typography>
                <Typography variant='body2' sx={{ color: shades.neutral[500] }}>
                  {group.description}
                </Typography>
                <Typography
                  variant='caption'
                  sx={{ color: shades.neutral[500] }}
                >
                  Admin: {group.adminUser.first_name}{' '}
                  {group.adminUser.last_name}
                </Typography>
              </Box>
            </Box>
            <Divider sx={{ my: 1 }} />
            <Box
              display='flex'
              alignItems='center'
              mb={2}
              sx={{ color: shades.neutral[500] }}
            >
              <Typography variant='body2' sx={{ mr: 1 }}>
                {group.members.length} member
                {group.members.length > 1 ? 's' : ''}
              </Typography>
              {group.members.map((member) => (
                <Avatar
                  key={member.id}
                  src={member.avatar}
                  sx={{ width: 24, height: 24, mr: 0.5 }}
                />
              ))}
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Button
                variant='outlined'
                size='small'
                sx={{
								  mr: 1,
								  borderColor: 'black',
								  color: 'black',
								  '&:hover': {
								    backgroundColor: 'black',
								    color: 'white',
								    borderColor: 'black'
                  }
                }}
              >
                Join
              </Button>
            </Box>
          </CardContent>
        </Card>
      ))}
    </Box>
  );
};

// Main Layout
const HomeGroups = () => {
  return (
    <Box
      sx={{
			  display: 'flex',
			  height: '100vh',
			  backgroundColor: shades.neutral[900]
      }}
    >
      <Navbar />
      <SideBar />
      <Groups />
      <Profile />
    </Box>
  );
};

export default HomeGroups;
